import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function EditIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.0362 0.978783C15.5782 1.52865 15.9152 2.19235 15.9852 2.84792C16.0652 3.58887 15.8192 4.2729 15.2732 4.82785L15.0422 5.06162C15.0412 5.06264 15.0407 5.06365 15.0402 5.06467C15.0397 5.06568 15.0392 5.0667 15.0382 5.06772L13.5462 6.58315C13.5459 6.58354 13.5455 6.58378 13.5452 6.58399C13.5446 6.58432 13.5442 6.58456 13.5442 6.58519C13.5436 6.58519 13.5434 6.58557 13.5431 6.58611C13.5429 6.58644 13.5426 6.58683 13.5422 6.58722L5.12033 14.944C5.04933 15.0141 4.96233 15.0588 4.87233 15.0781L0.879364 15.9837C0.826365 15.9949 0.773365 16 0.720366 16C0.527367 16 0.342369 15.9217 0.20437 15.7774C0.029372 15.5945 -0.0386274 15.3373 0.021372 15.0893L1.00736 11.0542C1.02736 10.9628 1.07436 10.8764 1.14436 10.8063L1.14636 10.8042L9.56629 2.4495L11.0103 0.981832C11.0108 0.981324 11.011 0.980816 11.0113 0.980307C11.0115 0.979799 11.0118 0.979291 11.0123 0.978783L11.2493 0.737899C11.7223 0.255114 12.3063 0 12.9343 0H12.9363C13.6692 0 14.4152 0.347605 15.0362 0.978783ZM12.9353 1.01639H12.9363C13.4023 1.01639 13.8962 1.25727 14.3292 1.69737C14.7112 2.08461 14.9452 2.53183 14.9912 2.95871C15.0322 3.33477 14.9192 3.67526 14.6732 3.97815L12.0933 1.3579C12.3493 1.14649 12.6283 1.01639 12.9353 1.01639ZM13.1973 5.50172L10.6193 2.81641L11.3673 2.05616L13.9772 4.70893L13.1973 5.50172ZM4.77933 13.8625L2.20135 11.1782L9.90728 3.53195L12.4853 6.21522L4.77933 13.8625ZM1.76336 12.1763L1.10036 14.8911L3.78634 14.2833L1.76336 12.1763Z'
      />
    </svg>
  );
}
